import React from 'react';

import cx from 'classnames'
import styles from './styles.module.scss';

interface WarningMessageProps {
  message: string;
  header: string;
  type: "WARNING" | "ERROR";
  actions?: React.ReactNode;
  className? : string;
}

const WarningMessage: React.FC<WarningMessageProps> = ({ message, header, type = "WARNING", actions, className}) => {
  return <div className={cx(styles.warningMessage, className,
    {
      [styles.warning]: type === 'WARNING',
      [styles.error]: type === 'ERROR'
    }
  )}>
    <div className={styles.headerContainer}>
      <p className={styles.header}>
        <i className="paperflite-danger" />
        {header}
      </p>
      {actions && <div>{actions}</div>}
    </div>
    <p className={styles.message}>
      {message}
    </p>
  </div>;
}

export default WarningMessage;